<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb
      :items="items"
      :canAddNew="!canAdd"
      search_route="/blogs/add"
      search_title="إضافه مقال"
      icon="fa-plus"
    />

    <MainLoader v-if="loading"></MainLoader>
    <div class="fadeIn" v-else>
      <!-- Start Main Section -->

      <main>
        <div class="d-flex flex-wrap py-5 justify-content-center">
          <div class="col-lg-4 py-0" v-for="blog in rows" :key="blog.id">
            <BlogCard
              :canDelete="!canDelete"
              :canEdit="!canEdit"
              :cardData="blog"
              @deleteThis="deleteItem"
            />
          </div>
        </div>
      </main>

      <!-- End Statistics Card-->

      <!-- Delete dialog -->
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5 justify-center">
            {{ $t("table.deletedialog.areYouSure") }}
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#fff" @click="deleteItemConfirm">
              {{ $t("table.deletedialog.ok") }}
            </v-btn>
            <v-btn color="#fff" @click="dialogDelete = false">
              {{ $t("table.deletedialog.cancel") }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Start Pagination -->
      <template>
        <div
          class="pagination_container tw-text-center mb-5 d-flex justify-content-end"
        >
          <v-pagination
            color="primary"
            v-model="paginations.current_page"
            :length="paginations.last_page"
            :total-visible="5"
            @input="fetchData($event)"
          ></v-pagination>
        </div>
      </template>
      <!-- End Pagination -->
    </div>
    <!-- Start Image_Model -->
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MainFilter from "../../../components/Filters/MainFilter.vue";

export default {
  components: {
    MainFilter,
    BlogCard: () => import("../../../components/UI/cards/blog.vue"),
  },
  data() {
    return {
      blogs: [
        {
          id: 1,
          description:
            "We aim to deliver high-quality products. Hence, we take care of everything at the granular level.",
          title: "The Complete Guide to Web Hosting",
          date: "30 Oct 2022",
          img: require("@/assets/images/blog/s1.png"),
          views: 2433,
          type: "Business",
        },
        {
          id: 2,
          description:
            "We aim to deliver high-quality products. Hence, we take care of everything at the granular level.",
          title: "The Complete Guide to Web Hosting",
          date: "20 Oct 2022",
          img: require("@/assets/images/blog/s2img3.png"),
          views: 2433,
          type: "Business",
        },
        {
          id: 3,
          description:
            "We aim to deliver high-quality products. Hence, we take care of everything at the granular level.",
          title: "The Complete Guide to Web Hosting",
          date: "25 Oct 2022",
          img: require("@/assets/images/blog/s2img2.png"),
          views: 2433,
          type: "Business",
        },
        {
          id: 4,
          description:
            "We aim to deliver high-quality products. Hence, we take care of everything at the granular level.",
          title: "The Complete Guide to Web Hosting",
          date: "20 Oct 2022",
          img: require("@/assets/images/blog/s2img3.png"),
          views: 2433,
          type: "Business",
        },
        {
          id: 5,
          description:
            "We aim to deliver high-quality products. Hence, we take care of everything at the granular level.",
          title: "The Complete Guide to Web Hosting",
          date: "25 Oct 2022",
          img: require("@/assets/images/blog/s2img2.png"),
          views: 2433,
          type: "Business",
        },
      ],
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.blogs.title"),
          disabled: false,
          href: "/blogs",
        },
        {
          text: this.$t("breadcrumb.blogs.all"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },

      // ========== Your Data
      rows: [], // injected in created

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 15,
      },
      showItems: [
        {
          id: 1,
          value: 5,
        },
        {
          id: 2,
          value: 10,
        },
        {
          id: 1,
          value: 20,
        },
      ],

      // ========== Loding
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
  },

  methods: {
    // ===== Search Method =====
    filterClick(word) {
      if (!this.loading) {
        this.search = word;
        this.helper_filterSearch();
      }
    },

    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/blogs/add" });
    },
    showItem(item) {
      this.$router.push({ path: "/blogs/show/" + item.id });
    },
    editItem(item) {
      this.$router.push({ path: "/blogs/edit/" + item.id });
    },
    addMeta(item) {
      this.$router.push({ path: "/blogs/meta/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.axios({
        method: "DELETE",
        url: `blog/${this.itemtoDelete}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows() {
      this.loading = true;
      const params = new URLSearchParams();
      params.append("page", this.paginations.current_page);
      // params.append('keyword', e?.searchInput ? e.searchInput : '')
      // params.append('code', e?.code ? e.code : '')
      // params.append('from_price', e?.start_price ? e.start_price : '')
      // params.append('to_price', e?.end_price ? e.end_price : '')
      // params.append(
      //   'category_id',
      //   e?.selectedCategory ? e.selectedCategory.id : '',
      // )
      // params.append('size', e?.size ? e.size.id : '')
      // params.append('color', e?.color ? e.color.id : '')

      // if (e?.feature) {
      //   e.feature.map((el, index) => {
      //     params.append(`features[${index}]`, el.id)
      //   })
      // }
      this.axios({
        method: "GET",
        url: "blog",
        params: params,
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;
          this.rows = res.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchData(e) {
      this.$router.replace({ query: { page: e } });
      this.setRows();
    },
  },

  // ======= hooks
  created() {
    this.canEdit = this.$permission.allowed("blogs/edit/");
    this.canDelete = this.$permission.allowed("blogs/delete");
    this.canAdd = this.$permission.allowed("blogs/add");
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setRows();
  },
};
</script>

<style lang="scss" scoped>
.image {
  width: 120px;
  img {
    width: 100%;
  }
}
</style>
